import { render, staticRenderFns } from "./ConfiguracionTable.vue?vue&type=template&id=37a9b64c&lang=pug&"
import script from "./ConfiguracionTable.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionTable.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports